import { createAction, props } from '@ngrx/store';
import { PersonContact } from '../_models';

// Load Actions
export const loadPersonContacts = createAction('[PersonContact] Load PersonContacts');
export const loadPersonContactsSuccess = createAction(
  '[PersonContact] Load PersonContacts Success',
  props<{ personContacts: PersonContact[] }>()
);
export const loadPersonContactsFailure = createAction(
  '[PersonContact] Load PersonContacts Failure',
  props<{ error: any }>()
);

// Add Actions
export const addPersonContact = createAction(
  '[PersonContact] Add PersonContact',
  props<{ personContact: PersonContact }>()
);
export const addPersonContactSuccess = createAction(
  '[PersonContact] Add PersonContact Success',
  props<{ personContact: PersonContact }>()
);
export const addPersonContactFailure = createAction(
  '[PersonContact] Add PersonContact Failure',
  props<{ error: any }>()
);

// Update Actions
export const updatePersonContact = createAction(
  '[PersonContact] Update PersonContact',
  props<{ personContact: PersonContact }>()
);
export const updatePersonContactSuccess = createAction(
  '[PersonContact] Update PersonContact Success',
  props<{ personContact: PersonContact }>()
);
export const updatePersonContactFailure = createAction(
  '[PersonContact] Update PersonContact Failure',
  props<{ error: any }>()
);

// Delete Actions
export const deletePersonContact = createAction(
  '[PersonContact] Delete PersonContact',
  props<{ id: number }>()
);
export const deletePersonContactSuccess = createAction(
  '[PersonContact] Delete PersonContact Success',
  props<{ id: number }>()
);
export const deletePersonContactFailure = createAction(
  '[PersonContact] Delete PersonContact Failure',
  props<{ error: any }>()
);
